'use client';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function GlobalError({ error, reset }: GlobalErrorProps) {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <html lang="en">
      <head>
        <title>Something went wrong | Inventive HQ</title>
      </head>
      <body>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#f9fafb',
          }}
        >
          <div style={{ maxWidth: '28rem', textAlign: 'center' }}>
            <h2
              style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#111827',
                marginBottom: '0.75rem',
              }}
            >
              Something went wrong
            </h2>

            <p
              style={{
                color: '#4b5563',
                marginBottom: '1.5rem',
              }}
            >
              We encountered an unexpected error loading this page. This may be
              due to a network issue.
            </p>

            <div
              style={{
                display: 'flex',
                gap: '0.75rem',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <button
                onClick={handleRefresh}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#2813e8',
                  color: 'white',
                  fontWeight: '500',
                  borderRadius: '0.5rem',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                Refresh Page
              </button>

              <button
                onClick={reset}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: 'white',
                  color: '#374151',
                  fontWeight: '500',
                  borderRadius: '0.5rem',
                  border: '1px solid #d1d5db',
                  cursor: 'pointer',
                }}
              >
                Try Again
              </button>
            </div>

            <p
              style={{
                marginTop: '1.5rem',
                fontSize: '0.875rem',
                color: '#6b7280',
              }}
            >
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
              <a href="/" style={{ color: '#2813e8', textDecoration: 'none' }}>
                Return to homepage
              </a>
            </p>
          </div>
        </div>
      </body>
    </html>
  );
}
